import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=3c63bdae&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=ts"
export * from "./CtaSection.vue?vue&type=script&lang=ts"
import style0 from "./CtaSection.vue?vue&type=style&index=0&id=3c63bdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63bdae",
  null
  
)

export default component.exports